import { CommonModule } from '@angular/common';
import { NgModule  } from '@angular/core';
import { SharedModule } from 'shared/shared.module';
import { PharmacistDetailHospitalComponent } from './admin/pharmacist/pharmacist-detail/pharmacist-detail-hospital.component';
import { PharmacistDetailPharmacyComponent } from './admin/pharmacist/pharmacist-detail/pharmacist-detail-pharmacy.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule
  ],
  declarations: [
    PharmacistDetailHospitalComponent,
    PharmacistDetailPharmacyComponent
  ],
  exports:[
    PharmacistDetailHospitalComponent,
    PharmacistDetailPharmacyComponent
  ],
  providers: []
})
export class DTPCoreModule {}
